import React, { useState, useEffect } from 'react';
// import '../styles.css';

import { toast } from 'react-toastify';
import SipHttp from './sip.service';

import { Button, Table } from 'react-bootstrap';
import { userStore } from 'store/UserStore';
import { makeQuery } from 'utils';
import Alert from 'shared/common/alert';
interface PropsType {}

const EmandateList: React.FC<PropsType> = ({}) => {
  const [loading, setLoading] = useState<any>(false);
  const [emandateList, setEmandateList] = useState<any>([]);
  const [customerId, setUser, user] = userStore((state: any) => [
    state.customerId,
    state.setUser,
    state.user,
  ]);

  const [open, setOpen] = useState<any>(false);
  const [emBank, setEmBank] = useState<any>('');
  const [emVpa, setEmVpa] = useState<any>('');

  const handleToggle = async (emBank, emVpa) => {
    try {
      const data = {
        bank: emBank,
        customerId: customerId,
        user_id: user?.userId,
        vpa: emVpa
      };

      const res = await SipHttp.changeEmandateStatus(data);
      if (res?.status == 200) {
        toast.success('E-Mandate deactivated successfully!');
        getEmandateList();
      } else {
        toast.error('Something went wrong');
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
    }
  };
  const getEmandateList = async () => {
    try {
      const query = makeQuery({
        customerId: customerId,
        user_id: user?.userId,
      });

      const res = await SipHttp.getEmandatesList(query, customerId);
      if (res?.status == 200) {
        setEmandateList(res?.data?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onSuccess = () => {
    // cancelFunction();
    handleToggle(emBank, emVpa);
    setOpen(false);
  };

  const onCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    getEmandateList();
  }, []);

  return (
    <>
      <div className='t-wrap overflow-auto'>
        <Table className='mb-0 w-100 txn__table' striped hover responsive>
          <thead>
            <tr>
              <th>Bank</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {emandateList?.length > 0 ? (
              emandateList?.map((em, index) => (
                <tr key={index}>
                  <td>{em?.bank ? em?.bank : em?.vpa}</td>
                  <td>{em?.status}</td>
                  <td>
                    {' '}
                    {em?.status == 'CONFIRMED' ? (
                      <Button
                        variant='primary'
                        onClick={() => {
                          setOpen(true);
                          setEmBank(em?.bank);
                          setEmVpa(em?.vpa);
                        }}
                        bsPrefix='btn-table'
                        size='sm'
                      >
                        Deactivate
                      </Button>
                    ) : (
                      <>
                        <div className='badge bg-secondary'>
                          <b> {em?.status}</b>
                        </div>
                      </>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3}>
                  <div className='m-2 d-flex justify-content-center'>
                    No data to display
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <Alert
          open={open}
          message='Are you sure you want to deactivate this E-Mandate? Once deactivated, you cannot reactivate it.'
          onSuccess={onSuccess}
          onCancel={onCancel}
        />
      </div>
    </>
  );
};

export default EmandateList;
